import { render, staticRenderFns } from "./UpiQrCode.vue?vue&type=template&id=745cabe0&scoped=true"
import script from "./UpiQrCode.vue?vue&type=script&lang=js"
export * from "./UpiQrCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745cabe0",
  null
  
)

export default component.exports